import { LuPencil } from "react-icons/lu";
import { useFormContext } from "react-hook-form";

import { formatInternational } from "../lib/phone";
import { answerKey, displayAnswer, splitUnit, visibleQuestions } from "../lib/questions";
import { useNationalities } from "./AboutStep";
import { GENDER, RESIDENCY } from "./steps";

const labelOf = (options, value) => options.find((o) => o.value === value)?.label ?? "";

const formatPhone = (phone) => (phone?.number ? formatInternational(phone.number, phone.country) : "");

function Group({ title, onEdit, children }) {
  return (
    <section className="cr-review-group">
      <div className="cr-review-head">
        <h2 className="cr-h3">{title}</h2>
        <button type="button" className="cr-btn cr-btn--ghost cr-btn--sm" onClick={onEdit}>
          <LuPencil aria-hidden="true" /> Edit<span className="cr-visually-hidden"> {title}</span>
        </button>
      </div>
      <dl className="cr-review-list">{children}</dl>
    </section>
  );
}

const Row = ({ label, value }) => (
  <>
    <dt>{label}</dt>
    <dd>{value || "Not given"}</dd>
  </>
);

export default function ReviewStep({ questions, onEdit }) {
  const { getValues } = useFormContext();
  const values = getValues();
  const { options: nationalities } = useNationalities();
  const nationality = nationalities.find((n) => String(n.id) === String(values.nationality))?.name;
  const answered = visibleQuestions(questions, values.answers || {});

  return (
    <div>
      <Group title="Contact details" onEdit={() => onEdit("contact")}>
        <Row label="Name" value={`${values.first_name} ${values.last_name}`.trim()} />
        <Row label="Email" value={values.email} />
        <Row label="Mobile" value={formatPhone(values.phone)} />
      </Group>
      <Group title="About you" onEdit={() => onEdit("about")}>
        <Row label="Nationality" value={nationality} />
        <Row label="Residency" value={labelOf(RESIDENCY, values.residence_status)} />
        <Row label="Gender" value={labelOf(GENDER, values.gender)} />
      </Group>
      <Group title="CV" onEdit={() => onEdit("cv")}>
        <Row label="File" value={values.resume_name || (values.resume ? "Uploaded" : "")} />
        <Row label="Note" value={values.cover_letter?.trim() ? values.cover_letter : "None"} />
      </Group>
      {answered.length > 0 && (
        <Group title="Your answers" onEdit={() => onEdit("questions")}>
          {answered.map((q) => (
            <Row
              key={q.id}
              label={splitUnit(q.text).label}
              value={displayAnswer(q, values.answers?.[answerKey(q.id)])}
            />
          ))}
        </Group>
      )}
      <p className="cr-consent">
        By sending this application you agree that Nando's UAE can use these details to consider
        you for this role and contact you about it.
      </p>
    </div>
  );
}
